import { FC, useRef } from "react";
import {
  Input,
  FormControl,
  FormHelperText,
  FormLabel,
  FormErrorMessage,
  InputProps,
} from "@chakra-ui/react";
import { useField } from "formik";

interface Props extends InputProps {
  name: string;
  label?: string;
  id: string;
  helper?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
}

const TextInput: FC<Props> = ({
  name,
  label,
  id,
  helper,
  placeholder,
  isRequired = false,
  isDisabled = false,
  isReadOnly = false,
  ...props
}) => {
  const [{ value }, meta, { setValue }] = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <FormControl
      isRequired={isRequired}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      isInvalid={Boolean(meta.touched && meta.error)}
    >
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <Input
        onChange={(e) => setValue(e.target.value)}
        ref={inputRef}
        id={id}
        name={name}
        type="text"
        value={value ?? ""}
        {...props}
      />
      {helper && <FormHelperText>{helper}</FormHelperText>}
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};

export default TextInput;
